import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  fetchOrganisationDashboardAnalytics,
  findOrganisationBranchesAction,
  findAllProducts,
  findFilteredOrganisationProducts,
  findOrganisationPercentageDiscount,
  findVoucherByCode,
  createBookingAction,
} from "./action";
import { InitialState, NewBookingData } from "./types";
import { AppointmentType } from "../../../enums/appointment-type.enum";
import { PaymentMethod } from "../../../enums/payment-method.enum";
import { PaymentStatus } from "../../../enums/payment-status.enum";
const initialNewBookingData = {
  paymentDetails: {
    total: 0,
    discount: 0,
    subTotal: 0,
    appliedVoucherCode: "",
    paymentMethod: PaymentMethod.B2bWallet,
    paymentStatus: PaymentStatus.OnHold,
    paymentPlan: "",
  },
  appointmentDetails: {
    proposedAppointmentDate: new Date(),
    proposedAppointmentTime: "",
    lineOfAddress: "",
    state: {
      _id: "",
      id: "",
      name: "",
      logisticsFee: 10000,
      logisticsFeePerOperation: [],
    },
    appointmentType: AppointmentType.HomeService,
    isWalkIn: false,
  },
  logisticsFeeData: [],
};
const initialState: InitialState = {
  loading: false,
  dashboardInfo: null,
  error: false,
  newBookingData: initialNewBookingData,
  organisationBranches: [],
  allProducts: [],
  message: null,
  errorMessage: "",
  priceListData: {
    products: [],
    total: 0,
  },
  promoCodeData: {},
  percentageDiscount: 0,
};

//slice here
const organisationSlice = createSlice({
  name: "organisation",
  initialState,
  reducers: {
  saveNewBookingData: (
      state,
      data: { type: string; payload: NewBookingData }
    ) => {
      state.newBookingData = data.payload;
    },

  resetNewBookingData: (state) => {
      state.newBookingData = initialNewBookingData;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchOrganisationDashboardAnalytics.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      fetchOrganisationDashboardAnalytics.fulfilled,
      (state, action: PayloadAction<any>) => {

        state.error = false;
        state.dashboardInfo = action?.payload?.payload;
        state.loading = false;
      }
    );

    builder.addCase(fetchOrganisationDashboardAnalytics.rejected, (state) => {
      state.loading = false;
      state.dashboardInfo = null;
      state.error = true;
    });

    //find organisation branches
    builder.addCase(findOrganisationBranchesAction.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      findOrganisationBranchesAction.fulfilled,
      (state, action: PayloadAction<any>) => {
  
        state.error = false;

        state.organisationBranches = action?.payload?.payload;
        state.loading = false;
      }
    );

    builder.addCase(findOrganisationBranchesAction.rejected, (state) => {
      state.loading = false;
      state.organisationBranches = [];
      state.error = true;
    });

    //find all products
    builder.addCase(findAllProducts.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      findAllProducts.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.error = false;
        state.allProducts = action?.payload?.payload;
        state.loading = false;
      }
    );
    builder.addCase(findAllProducts.rejected, (state) => {
      state.loading = false;
      state.allProducts = [];
      state.error = true;
    });

    //create booking
    builder.addCase(createBookingAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      createBookingAction.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.error = false;
        state.message = action?.payload;
        state.loading = false;
      }
    );
    builder.addCase(
      createBookingAction.rejected,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = true;
      }
    );

    builder.addCase(findFilteredOrganisationProducts.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      findFilteredOrganisationProducts.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.error = false;
        state.priceListData = action?.payload?.payload;
        state.loading = false;
      }
    );
    builder.addCase(
      findFilteredOrganisationProducts.rejected,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = true;
      }
    );

    //percentage discount
    builder.addCase(findOrganisationPercentageDiscount.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      findOrganisationPercentageDiscount.fulfilled,
      (state, action: PayloadAction<{ payload: { discount: number } }>) => {
        state.loading = false;
        state.percentageDiscount = action.payload?.payload?.discount;
      }
    );

    builder.addCase(
      findOrganisationPercentageDiscount.rejected,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = true;
      }
    );
    builder.addCase(findVoucherByCode.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      findVoucherByCode.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.error = false;
        state.promoCodeData = action?.payload?.payload;
        state.loading = false;
      }
    );
    builder.addCase(
      findVoucherByCode.rejected,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = true;
      }
    );
  },
});

export default organisationSlice.reducer;
export const { saveNewBookingData, resetNewBookingData } = organisationSlice.actions;
